export const redirect = (path) => ({
	type: 'REDIRECT',
	path: `/${path}`,
	// history,
});
